<template>
  <v-app style="background:white">
    <!--
          |\_/|
          | @ @   Woof!
          |   <>              _
          |  _/\------____ ((| |))
          |               `--' |
      ____|_       ___|   |___.'
      /_/_____/____/_______|
    -->
    <nav-bar v-if="!shouldHideNavBar"></nav-bar>
    <v-content id="main-content" :class="{ 'content-top-offeset' : shouldHideNavBar}">
      <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-content>
    <Footer v-if="!shouldHideFooter" id="onebyone-footer"></Footer>
  </v-app>
</template>

<script>
import NavBar from "@/components/NavBar";
import Footer from "@/components/Footer";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    NavBar,
    Footer
  },
  computed: {
    shouldHideNavBar() {
      return this.$route.meta.hideNavigation;
    },
    shouldHideFooter() {
      return this.$route.meta.hideFooter;
    },
    ...mapState("nav", ["showHamburgerMenu"])
  }
};
</script>


<style>
@import "./styles/common.css";
@import "./styles/transition.css";
@import "./styles/supportCommon.css";

@media only screen and (min-width: 960px) {
  main:not(.content-top-offeset) {
    margin-top: var(--nav-height);
  }
}
</style>